export default __webpack_public_path__ + "static/cta-plants-1-d526cbfcd60332f41a6de694dbf869c6.jpg";